<template>
  <v-app>
    <v-content class="panel-background">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Sign Up for wots nu?</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-card-text>
                  <v-alert
                    v-model="alert"
                    dismissible
                    v-bind:type="alertType"
                  >
                    {{ alertText }}
                  </v-alert>
                </v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" name="username" label="Enter a username"
                                 type="text" v-model="username"></v-text-field>
                  <v-text-field prepend-icon="email" name="email" label="Enter your email address"
                                type="email" v-model="email"></v-text-field>
                  <v-text-field id="password" prepend-icon="lock" name="password" label="Enter password"
                                type="password" v-model="password"></v-text-field>
                  <v-text-field id="password2" prepend-icon="lock" name="password2" label="Re-enter password"
                                type="password" v-model="password2"></v-text-field>
                  <v-text-field prepend-icon="subject" name="invitation" label="Enter invite code"
                                type="text" v-model="invitationCode"></v-text-field>
                </v-form>
                <v-card-text>
                  Back to
                  <router-link to="/login">Log In</router-link>
                  <br/>
                  Forgot password?
                  <router-link to="/reset">Reset here</router-link>
                  <br/>
                  <br/>
                  <span class="grey--text">&copy; 2018 wots.nu</span>
                </v-card-text>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="signUp">Sign Up</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const fb = require('../firebase')

export default {
  name: 'UserJoin',
  data () {
    return {
      alert: false,
      alertText: 'hello world',
      alertType: 'error',
      username: '',
      email: '',
      password: '',
      password2: '',
      invitationCode: ''
    }
  },
  mounted () {
    let user = fb.auth.currentUser
    if (user) {
      this.$router.push({path: '/home'})
    }
  },
  methods: {
    signUp: function () {
      if (this.username === '' || this.email === '' || this.password === '' || this.password2 === '' || this.invitationCode === '') {
        this.alertText = 'Please complete all fields.'
        this.alert = true
      } else if (this.invitationCode !== 'newpath') {
        this.alertText = 'Please enter a valid invite code.'
        this.alert = true
      } else if (this.password !== this.password2) {
        this.alertText = 'Passwords must match.'
        this.alert = true
      } else {
        fb.auth.createUserWithEmailAndPassword(this.email, this.password)
          .then(
            () => {
              fb.usersCollection.doc(fb.auth.currentUser.uid).set({
                email: fb.auth.currentUser.email,
                created: new Date(),
                updated: new Date(),
                name: this.username
              }).then(() => {
                fb.groupsCollection
                  .doc('TXOSAetRGy7ZpqV4gn51')
                  .get()
                  .then((doc) => {
                    let users = doc.data().users
                    users.push(fb.usersCollection.doc(fb.auth.currentUser.uid))
                    fb.groupsCollection.doc('TXOSAetRGy7ZpqV4gn51').set({
                      users: users
                    }, { merge: true })
                  })

                this.alertText = ''
                this.alert = false
                this.$router.push({path: '/home'})
              })
            },
            (err) => {
              this.alertText = err.message + ' Please try again.'
              this.alert = true
            }
          )
      }
    }
  }
}
</script>

<style scoped>
  .panel-background {
    background: #d5412b;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserJoin.vue